module.exports = __webpack_public_path__ + "assets/missing-education-organization-picture.85aaca99.png";